// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type ExtendedPropertyUri from '../contract/ExtendedPropertyUri';

export default function extendedPropertyUri(data: ExtendedPropertyUri): ExtendedPropertyUri {
    const result: ExtendedPropertyUri = {
        __type: 'ExtendedPropertyUri:#Exchange',
        ...data,
    };

    return result;
}
